import { displayToast } from '../../components/Toaster/displayToast';

const duplicateDashboardFetcher = (
    successMessage: string,
    errorMessage: string,
    surveyId: string,
    dashboardId: string,
    selectedSchema: string,
) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    myHeaders.append('X-Selected-Schema', selectedSchema);

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
    };

    const url = `${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/duplicate/`;

    return fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');

                return undefined;
            }
            displayToast(successMessage, 'success');

            return response.json();
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default duplicateDashboardFetcher;
